// Setas numa grade de cartões (Mesas, 26/10/2026): vai para o cartão mais
// perto na direção da seta, olhando a posição na tela — funciona com qualquer
// número de colunas e com as seções (Aguardando pagamento, Abertas, Fechadas)
// uma embaixo da outra. Puro: recebe as caixas, devolve o id.

const centro = (c) => [c.x + c.w / 2, c.y + c.h / 2];

/** caixas: [{ id, x, y, w, h }] na ordem da tela. Devolve o id de destino. */
export function vizinho(caixas, atualId, tecla) {
  if (!caixas || !caixas.length) return null;
  const i = caixas.findIndex((c) => c.id === atualId);
  if (i < 0) return caixas[0].id;
  const a = caixas[i];
  const [cx, cy] = centro(a);

  if (tecla === "ArrowRight" || tecla === "ArrowLeft") {
    const dir = tecla === "ArrowRight" ? 1 : -1;
    const naLinha = caixas.filter((c) => c.id !== a.id
      && Math.abs(centro(c)[1] - cy) < a.h / 2 && (centro(c)[0] - cx) * dir > 0);
    if (naLinha.length) {
      return naLinha.reduce((m, c) => (Math.abs(centro(c)[0] - cx) < Math.abs(centro(m)[0] - cx) ? c : m)).id;
    }
    // Fim da linha: segue para o próximo (ou anterior) na ordem da tela
    const j = i + dir;
    return j >= 0 && j < caixas.length ? caixas[j].id : a.id;
  }

  if (tecla === "ArrowDown" || tecla === "ArrowUp") {
    const dir = tecla === "ArrowDown" ? 1 : -1;
    const adiante = caixas.filter((c) => (centro(c)[1] - cy) * dir > a.h / 2);
    if (!adiante.length) return a.id;
    const dyMin = Math.min(...adiante.map((c) => Math.abs(centro(c)[1] - cy)));
    const linha = adiante.filter((c) => Math.abs(Math.abs(centro(c)[1] - cy) - dyMin) < a.h / 2);
    return linha.reduce((m, c) => (Math.abs(centro(c)[0] - cx) < Math.abs(centro(m)[0] - cx) ? c : m)).id;
  }
  return a.id;
}

export const SETAS = ["ArrowRight", "ArrowLeft", "ArrowDown", "ArrowUp"];
